import type {ChatState} from '@microsoft/agent-host-protocol'
import {createContext} from 'react'

import type {AhpSessionIdentifiers} from '@github-ui/ahp-session-client/contracts'

export interface ThreadTitleState {
  userSet: boolean
  title?: string
}

export interface ThreadTitleActions {
  setUserThreadTitle: (title: string) => void
  onSessionRenamed?: (taskId: string, title: string) => void
  onUserRename?: () => void
}

export const NativeAhpSessionContext = createContext<AhpSessionIdentifiers | undefined | null>(null)
export const NativeAhpTimelineStateContext = createContext<ChatState | undefined | null>(null)
export const NativeAhpTimelineErrorContext = createContext<string | undefined | null>(null)
export const ThreadTitleStateContext = createContext<ThreadTitleState | null>(null)
export const ThreadTitleActionsContext = createContext<ThreadTitleActions | null>(null)
